import HttpService from '~/zf/frontend/common/http/HttpService';
import { PerformanceOverviewEndpoint } from '../../../common/endpoints/modules/portlets/PerformanceOverviewEndpoint';
import ColumnId from '../const/ColumnId';

function isColumnRequired(columnId) {
  return [
    ColumnId.STATUS,
    ColumnId.bezeichnung,
    ColumnId.LOCAL_TIMEZONE_OFFSET,
  ].includes(columnId);
}

function sortSelected(selected, all) {
  const requiredColumns = all.filter((column) => isColumnRequired(column));
  return requiredColumns.concat(selected);
}

async function saveColumnSettings(portletUid, columns) {
  return HttpService.post(
    PerformanceOverviewEndpoint.SAVE_COLUMNS_SETTINGS,
    {
      portletUid,
      'config-columns': columns,
    },
  );
}

export default {
  sortSelected,
  saveColumnSettings,
};
